import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-266">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-267">
          <div className="bg-white rounded-xl shadow-2xl border border-zinc-200 p-4 pr-10 relative overflow-hidden" data-id="element-268">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-500" data-id="element-269"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-400 hover:text-zinc-600 p-1" aria-label="Cerrar notificación" data-id="element-270">
              <X className="w-4 h-4" data-id="element-271" />
            </button>

            <div className="flex items-start gap-3" data-id="element-272">
              <div className="mt-0.5 shrink-0" data-id="element-273">
                <CheckCircle2 className="w-5 h-5 text-amber-500" data-id="element-274" />
              </div>
              <div data-id="element-275">
                <p className="text-xs font-bold text-amber-600 uppercase tracking-wider mb-1" data-id="element-276">
                  Compra verificada
                </p>
                <p className="text-sm text-zinc-700 leading-tight" data-id="element-277">
                  <strong data-id="element-278">Martín R.</strong> de Buenos Aires compró
                  <br data-id="element-279" />
                  <span className="text-amber-700 font-medium" data-id="element-280">
                    Megapack Herrero Argentino 🔨🇦🇷
                  </span>
                </p>
                <p className="text-xs text-zinc-400 mt-2" data-id="element-281">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}